import generateFileTypeErrorMessage from "@/utils/generate-file-type-error-message"

export const extensionList = ['.pdf', '.doc', '.docx', '.tt', '.png', '.jpg', '.jpeg', '.tif', '.tiff', '.dcm', '.gif', '.bmp', '.dicom', '.heic', '.ppt', '.pptx', '.xls', '.xlsx', '.xml', '.eml', '.msg']
const fileExtensions = {
    type: extensionList.join(', '),
    errorMessage: generateFileTypeErrorMessage(extensionList),
}

export default fileExtensions
